// Format names for display only; keep the original value for editing and saving.
export function formatDisplayName(value = "") {
  if (typeof value !== "string" || value.includes("@")) return value || "";

  return value.replace(/[\p{L}\p{M}]+/gu, (part) => {
    if (part !== part.toUpperCase() && part !== part.toLowerCase()) return part;
    const lower = part.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  });
}
